webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/studio308-logo.png";

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(904),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageNotFound__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Projects_Projects__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Projects_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Projects_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Projects_Status__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Projects_Status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Projects_Status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Projects_Type__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Projects_Type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Projects_Type__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Services_Services__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Services_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Services_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Team_Team__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Team_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Team_Team__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Home___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_2__components_About___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Contact___default.a
  }, {
    path: '/projects/statuses/:alias',
    name: 'project-status',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Projects_Status___default.a
  }, {
    path: '/projects/types/:alias',
    name: 'project-type',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Projects_Type___default.a
  }, {
    path: '/projects',
    name: 'projects',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Projects_Projects___default.a
  }, {
    path: '/services',
    name: 'services',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Services_Services___default.a
  }, {
    path: '/team',
    name: 'team',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Team_Team___default.a
  }, {
    path: '*',
    name: 'page-not-found',
    component: __WEBPACK_IMPORTED_MODULE_5__components_PageNotFound___default.a
  }]
}));

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  studio308: {
    name: 'Studio 308',
    description: 'Studio 308 is a boutique creation company. We dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.',
    links: {
      website: 'https://studio308.co',
      github: 'https://github.com/studio308',
      twitter: 'https://twitter.com/_studio308',
      instagram: '',
      linkedin: '',
      google_plus: '',
      facebook: ''
    }
  },
  links: [{
    name: 'Home',
    to: 'home'
  }, {
    name: 'Services',
    to: 'services'
  }, {
    name: 'Projects',
    to: 'projects'
  }, {
    name: 'Team',
    to: 'team'
  }, {
    name: 'About',
    to: 'about'
  }, {
    name: 'Contact',
    to: 'contact'
  }],
  projects: [{
    title: 'Film Club',
    alias: 'filmclub',
    description: '',
    links: {
      website: ''
    },
    status: {
      title: 'In Analysis',
      alias: 'in_analysis',
      description: ''
    },
    types: [{
      title: 'Web',
      alias: 'web',
      description: ''
    }, {
      title: 'Mobile',
      alias: 'mobile',
      description: ''
    }]
  }, {
    title: 'Howie',
    alias: 'howie',
    description: '',
    links: {
      website: ''
    },
    status: {
      title: 'In Analysis',
      alias: 'in_analysis',
      description: ''
    },
    types: [{
      title: 'Web',
      alias: 'web',
      description: ''
    }, {
      title: 'Mobile',
      alias: 'mobile',
      description: ''
    }]
  }, {
    title: 'Bone Loss Calculator',
    alias: 'bone_loss_calculator',
    description: '',
    links: {
      website: ''
    },
    status: {
      title: 'In Progress',
      alias: 'in_progress',
      description: ''
    },
    types: [{
      title: 'Web',
      alias: 'web',
      description: ''
    }, {
      title: 'Mobile',
      alias: 'mobile',
      description: ''
    }]
  }, {
    title: 'Jonny Pickett Website',
    alias: 'jonny_pickett_website',
    description: '',
    links: {
      website: 'https://jonnypickett.com'
    },
    status: {
      title: 'In Progress',
      alias: 'in_progress',
      description: ''
    },
    types: [{
      title: 'Web',
      alias: 'web',
      description: ''
    }]
  }, {
    title: 'Whitnee Wright Portfolio Website',
    alias: 'whitnee_wright_portfolio_website',
    description: '',
    links: {
      website: 'https://whitneewright.com'
    },
    status: {
      title: 'In Progress',
      alias: 'in_progress',
      description: ''
    },
    types: [{
      title: 'Web',
      alias: 'web',
      description: ''
    }]
  }],
  services: [{
    title: 'Design',
    hash: '#design',
    description: 'Have an idea yet don\'t know exactly how it will work? We will take your idea and transform it from the beautifully intangible collection of thoughts into a concrete plan of action ready to be executed.'
  }, {
    title: 'Build',
    hash: '#build',
    description: 'It\'s one thing to have a plan of how something can be accomplished. It\'s another thing entirely to accomplish it. And we do that. With our breadth of knowledge in web and mobile development coupled with our project management experience, your product will be done on time.'
  }, {
    title: 'Deploy',
    hash: '#deploy',
    description: 'It\'s the moment you\'ve been waiting for. Everything is built, and you love it. Getting your product out into the world can sometimes be just as difficult, if not more so, as building it. We will ensure that your mobile app gets to it\'s proper store and your web app gets out to that wonderful world wide web as smoothly as can be.'
  }, {
    title: 'Maintain',
    hash: '#maintain',
    description: 'Let\'s face it. Things change. We will help you cope with it (as long as the change we\'re talking about pertains to your mobile or web products). We will help you when you need to change the content or structure of your product, or your product needs to change to keep up with the ever changing technical landscape.'
  }, {
    title: 'Repair',
    hash: '#repair',
    description: 'Sometimes you\'re not happy with what you\'ve got. Let us know. We\'ll take a look and find a way to turn those frowns upside down. Yeah, we do that, too.'
  }],
  statuses: [{
    title: 'In Analysis',
    alias: 'in_analysis',
    description: '',
    projects: [{
      title: 'Film Club',
      alias: 'filmclub',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }]
    }, {
      title: 'Howie',
      alias: 'howie',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }]
    }]
  }, {
    title: 'In Progress',
    alias: 'in_progress',
    description: '',
    projects: [{
      title: 'Bone Loss Calculator',
      alias: 'bone_loss_calculator',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }, {
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }, {
      title: 'Jonny Pickett Website',
      alias: 'jonny_pickett_website',
      description: '',
      links: {
        website: 'https://jonnypickett.com'
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }, {
      title: 'Whitnee Wright Portfolio Website',
      alias: 'whitnee_wright_portfolio_website',
      description: '',
      links: {
        website: 'https://whitneewright.com'
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }]
  }, {
    title: 'Completed',
    alias: 'completed',
    description: '',
    projects: []
  }],
  types: [{
    title: 'Web',
    alias: 'web',
    description: '',
    projects: [{
      title: 'Film Club',
      alias: 'filmclub',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }]
    }, {
      title: 'Howie',
      alias: 'howie',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }]
    }, {
      title: 'Bone Loss Calculator',
      alias: 'bone_loss_calculator',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }, {
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }, {
      title: 'Jonny Pickett Website',
      alias: 'jonny_pickett_website',
      description: '',
      links: {
        website: 'https://jonnypickett.com'
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }, {
      title: 'Whitnee Wright Portfolio Website',
      alias: 'whitnee_wright_portfolio_website',
      description: '',
      links: {
        website: 'https://whitneewright.com'
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }]
  }, {
    title: 'Mobile',
    alias: 'mobile',
    description: '',
    projects: [{
      title: 'Film Club',
      alias: 'filmclub',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }]
    }, {
      title: 'Howie',
      alias: 'howie',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      },
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }]
    }, {
      title: 'Bone Loss Calculator',
      alias: 'bone_loss_calculator',
      description: '',
      links: {
        website: ''
      },
      status: {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      },
      types: [{
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }, {
        title: 'Web',
        alias: 'web',
        description: ''
      }]
    }]
  }, {
    title: 'Game',
    alias: 'game',
    description: '',
    projects: []
  }],
  teammates: [{
    full_name: 'Jonny Pickett',
    description: 'Jonny Pickett is pretty great.',
    github_username: 'jonnypickett',
    email: 'jonathan@studio308.co',
    links: {
      website: 'https://jonnypickett.com',
      github: 'https://github.com/jonnypickett',
      twitter: 'https://twitter.com/jonnypickett',
      instagram: 'https://www.instagram.com/jonnypickett',
      linkedin: 'https://www.linkedin.com/in/jonathanpickett',
      google_plus: 'https://plus.google.com/u/2/108228820594969320563',
      facebook: ''
    }
  }, {
    full_name: 'Jordan Pickett',
    description: 'Jordan Pickett is pretty great, too.',
    github_username: 'jordanepickett',
    email: 'jordan@studio308.co',
    links: {
      website: '',
      github: 'https://github.com/jordanepickett',
      twitter: '',
      instagram: '',
      linkedin: 'https://www.linkedin.com/in/jordan-pickett-70a241123',
      google_plus: 'https://plus.google.com/u/2/114383669972380804911',
      facebook: ''
    }
  }]
});

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(908),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavigationIcon__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavigationIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_NavigationIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageFooter__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageFooter__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      menuOpen: false,
      scrollPosition: 0
    };
  },

  methods: {
    toggleMenuState: function toggleMenuState() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu: function closeMenu() {
      this.menuOpen = false;
    },
    handleScroll: function handleScroll() {
      this.scrollPosition = window.scrollY;
    }
  },
  computed: {
    appClasses: function appClasses() {
      return this.menuOpen ? 'menu-open' : '';
    },
    navIconClasses: function navIconClasses() {
      return this.menuOpen ? 'open' : '';
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  components: {
    NavigationIcon: __WEBPACK_IMPORTED_MODULE_0__components_NavigationIcon___default.a,
    NavigationMenu: __WEBPACK_IMPORTED_MODULE_1__components_NavigationMenu___default.a,
    PageFooter: __WEBPACK_IMPORTED_MODULE_2__components_PageFooter___default.a
  }
});

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {
      studio308: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].studio308
    };
  },

  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      msg: 'Studio 308 Contact'
    };
  },

  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a
  }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact-button',
  data: function data() {
    return {
      msg: 'Studio 308 Contact'
    };
  }
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'copyright',
  data: function data() {
    return {
      studio308: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].studio308
    };
  },

  methods: {
    scrollTop: function scrollTop() {
      this.$scrollTo('html, body');
    }
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-title',
  props: {
    link: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  props: {
    scrollPosition: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      studio308: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].studio308,
      projects: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].projects,
      services: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].services
    };
  },

  computed: {
    menuServices: function menuServices() {
      return this.services.slice(0, 4);
    }
  },
  methods: {
    scrollTop: function scrollTop() {
      this.$scrollTo('html, body');
    }
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a
  }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  props: {
    navIconClasses: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    toggleMenuState: function toggleMenuState() {
      this.$emit('toggle-menu-state');
    }
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      title: '',
      links: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].links,
      delay: 380
    };
  },

  methods: {
    linkClasses: function linkClasses(link) {
      return this.$route.name === link.to ? 'active' : '';
    },
    handleNavigation: function handleNavigation() {
      this.$emit('navigating');
      this.scrollTop();
    },
    scrollTop: function scrollTop() {
      this.$scrollTo('html, body');
    }
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactButton__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ContactButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Copyright__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialIcons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SocialIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_SocialIcons__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-footer',
  data: function data() {
    return {
      studio308: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].studio308
    };
  },

  components: {
    ContactButton: __WEBPACK_IMPORTED_MODULE_1__components_ContactButton___default.a,
    Copyright: __WEBPACK_IMPORTED_MODULE_2__components_Copyright___default.a,
    SocialIcons: __WEBPACK_IMPORTED_MODULE_3__components_SocialIcons___default.a
  }
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-header',
  data: function data() {
    return {
      title: ''
    };
  },

  methods: {
    logoClicked: function logoClicked() {
      this.$emit('logo-clicked');
    }
  }
});

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-not-found',
  data: function data() {
    return {
      title: 'Page Not Found'
    };
  },

  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      msg: 'Studio 308 Project'
    };
  },

  methods: {
    scrollTop: function scrollTop() {
      this.$scrollTo('html, body');
    }
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Project__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Project__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  data: function data() {
    return {
      projects: [{
        title: 'Recipes',
        alias: 'recipes',
        description: '',
        links: {
          website: ''
        },
        status: {
          title: 'In Analysis',
          alias: 'in_analysis',
          description: ''
        },
        types: [{
          title: 'Web',
          alias: 'web',
          description: ''
        }, {
          title: 'Mobile',
          alias: 'mobile',
          description: ''
        }]
      }, {
        title: 'Truth or Dare',
        alias: 'truth_or_dare',
        description: '',
        links: {
          website: ''
        },
        status: {
          title: 'In Progress',
          alias: 'in_progress',
          description: ''
        },
        types: [{
          title: 'Mobile',
          alias: 'mobile',
          description: ''
        }]
      }, {
        title: 'Jonny Pickett Website',
        alias: 'jonny_pickett_website',
        description: '',
        links: {
          website: 'https://jonnypickett.com'
        },
        status: {
          title: 'In Progress',
          alias: 'in_progress',
          description: ''
        },
        types: [{
          title: 'Web',
          alias: 'web',
          description: ''
        }]
      }, {
        title: 'Whitnee Wright Portfolio Website',
        alias: 'whitnee_wright_portfolio_website',
        description: '',
        links: {
          website: 'https://whitneewright.com'
        },
        status: {
          title: 'In Progress',
          alias: 'in_progress',
          description: ''
        },
        types: [{
          title: 'Web',
          alias: 'web',
          description: ''
        }]
      }],
      statuses: [{
        title: 'In Analysis',
        alias: 'in_analysis',
        description: ''
      }, {
        title: 'In Progress',
        alias: 'in_progress',
        description: ''
      }, {
        title: 'Completed',
        alias: 'completed',
        description: ''
      }],
      types: [{
        title: 'Web',
        alias: 'web',
        description: ''
      }, {
        title: 'Mobile',
        alias: 'mobile',
        description: ''
      }, {
        title: 'Game',
        alias: 'game',
        description: ''
      }]
    };
  },

  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_0__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    Project: __WEBPACK_IMPORTED_MODULE_2__Project___default.a
  }
});

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects-menu',
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    baseLink: {
      type: String,
      required: true
    },
    currentItem: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Project__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectsMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectsMenu__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  data: function data() {
    return {
      statuses: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].statuses
    };
  },

  computed: {
    currentStatus: function currentStatus() {
      var _this = this;

      return this.statuses.find(function (status) {
        return status.alias === _this.$route.params.alias;
      });
    }
  },
  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    Project: __WEBPACK_IMPORTED_MODULE_3__Project___default.a,
    ProjectsMenu: __WEBPACK_IMPORTED_MODULE_4__ProjectsMenu___default.a
  }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Project__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectsMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectsMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ProjectsMenu__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  data: function data() {
    return {
      types: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].types
    };
  },

  computed: {
    currentType: function currentType() {
      var _this = this;

      return this.types.find(function (type) {
        return type.alias === _this.$route.params.alias;
      });
    }
  },
  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    Project: __WEBPACK_IMPORTED_MODULE_3__Project___default.a,
    ProjectsMenu: __WEBPACK_IMPORTED_MODULE_4__ProjectsMenu___default.a
  }
});

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'service',
  props: {
    service: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      msg: 'Studio 308 Service'
    };
  },

  methods: {
    makeActive: function makeActive() {
      this.$emit('activated');
    }
  }
});

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Service__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Service__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'services',
  props: {
    scrollPosition: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      services: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].services,
      activeService: null
    };
  },
  mounted: function mounted() {
    var hash = window.location.hash;
    if (hash) {
      this.setActiveService(this.services.indexOf(this.services.find(function (service) {
        return service.hash === hash;
      })));
      this.$scrollTo(hash);
    }
  },

  computed: {
    menuServices: function menuServices() {
      return this.services.slice(0, 4);
    }
  },
  methods: {
    setActiveService: function setActiveService(index) {
      this.activeService = this.services[index];
    }
  },
  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    Service: __WEBPACK_IMPORTED_MODULE_3__Service___default.a
  }
});

/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'social-icons',
  props: {
    scale: {
      type: Number,
      default: 1
    },
    website: {
      type: String
    },
    twitter: {
      type: String
    },
    github: {
      type: String
    },
    instagram: {
      type: String
    },
    linkedin: {
      type: String
    },
    googlePlus: {
      type: String
    },
    facebook: {
      type: String
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Teammate__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Teammate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Teammate__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team',
  props: {
    scrollPosition: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      teammates: __WEBPACK_IMPORTED_MODULE_0__storage_data__["a" /* default */].teammates
    };
  },

  components: {
    HeaderTitle: __WEBPACK_IMPORTED_MODULE_1__components_HeaderTitle___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    Teammate: __WEBPACK_IMPORTED_MODULE_3__Teammate___default.a
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialIcons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SocialIcons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SocialIcons__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teammate',
  props: {
    teammate: {
      type: Object,
      required: true
    },
    githubUsername: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      imageUrl: null
    };
  },
  created: function created() {
    var _this = this;

    this.axios.get(this.userUrl).then(function (res) {
      _this.imageUrl = res.data.avatar_url;
    }).catch(function (e) {
      console.log(e);
    });
  },

  computed: {
    userUrl: function userUrl() {
      return 'https://api.github.com/users/' + this.githubUsername;
    }
  },
  components: {
    SocialIcons: __WEBPACK_IMPORTED_MODULE_0__components_SocialIcons___default.a
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(921),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(912),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(919),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(55),
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(914),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(916),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(903),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(905),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(907),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(918),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(913),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(920),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(906),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 903:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/projects",
      "title": "Projects"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.")]), _vm._v(" "), (_vm.projects.length) ? _c('div', {
    staticClass: "projects"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('project', {
      key: index,
      attrs: {
        "project": project
      }
    })
  }), 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 904:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.menuItems), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      class: _vm.currentItem == item ? 'active' : null,
      attrs: {
        "to": {
          name: _vm.baseLink,
          params: {
            alias: item.alias
          }
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/projects",
      "title": "Projects"
    }
  }), _vm._v(" "), _c('projects-menu', {
    attrs: {
      "menu-items": _vm.statuses,
      "base-link": 'project-status',
      "currentItem": _vm.currentStatus
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.")]), _vm._v(" "), (_vm.currentStatus.projects.length) ? _c('div', {
    staticClass: "projects"
  }, _vm._l((_vm.currentStatus.projects), function(project, index) {
    return _c('project', {
      key: index,
      attrs: {
        "project": project
      }
    })
  }), 1) : _c('h2', {
    staticClass: "align-center",
    attrs: {
      "id": "empty-status"
    }
  }, [_vm._v("We don't have any projects " + _vm._s(_vm.currentStatus.title.toLowerCase()) + ". Don't judge us!")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 906:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.teammate.full_name) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content teammate-content"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    staticClass: "profile-photo",
    attrs: {
      "src": _vm.imageUrl
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.teammate.description))]), _vm._v(" "), _c('social-icons', {
    attrs: {
      "scale": 1.5,
      "website": _vm.teammate.links.website,
      "twitter": _vm.teammate.links.twitter,
      "github": _vm.teammate.links.github,
      "instagram": _vm.teammate.links.instagram,
      "linkedin": _vm.teammate.links.linkedin,
      "google-plus": _vm.teammate.links.google_plus,
      "facebook": _vm.teammate.links.facebook
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/projects",
      "title": "Projects"
    }
  }), _vm._v(" "), _c('projects-menu', {
    attrs: {
      "menu-items": _vm.types,
      "base-link": 'project-type',
      "currentItem": _vm.currentType
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.")]), _vm._v(" "), (_vm.currentType.projects.length) ? _c('div', {
    staticClass: "projects"
  }, _vm._l((_vm.currentType.projects), function(project, index) {
    return _c('project', {
      key: index,
      attrs: {
        "project": project
      }
    })
  }), 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo",
    on: {
      "click": _vm.logoClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('img', {
    staticClass: "dark",
    attrs: {
      "src": __webpack_require__(100),
      "id": "logo",
      "alt": "image"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 909:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [(_vm.website) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.website,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "laptop",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.twitter) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.twitter,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.github) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.github,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "github",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instagram) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.instagram,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.linkedin) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.linkedin,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.googlePlus) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.googlePlus,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "google-plus",
      "scale": _vm.scale
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.facebook) ? _c('a', {
    staticClass: "easy",
    attrs: {
      "href": _vm.facebook,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook",
      "scale": _vm.scale
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "description"
    }
  }, [_vm._v(_vm._s(_vm.studio308.description))])]), _vm._v(" "), _c('div', {
    ref: "subsections",
    attrs: {
      "id": "sub-sections"
    }
  }, [_c('div', {
    staticClass: "sub-section align-left",
    attrs: {
      "id": "services"
    }
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('router-link', {
    attrs: {
      "to": 'services',
      "exact": ""
    }
  }, [_vm._v("Services")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "hover-light"
  }, [_vm._v("We want to help you out, and we do a lot of things, so odds are that what you need done matches up with what we're able to do. Whether you need help fleshing out your idea and how to implement it, or you need help building out what you've already planned, or you just need some things fixed and maintained, we've got you covered.")]), _vm._v(" "), _c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.menuServices), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": 'services' + service.hash,
        "exact": ""
      }
    }, [_vm._v(_vm._s(service.title))])], 1)
  }), 0)]), _vm._v(" "), (_vm.projects.length) ? _c('div', {
    staticClass: "sub-section align-right",
    attrs: {
      "id": "projects"
    }
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('router-link', {
    attrs: {
      "to": 'projects'
    }
  }, [_vm._v("Projects")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "hover-light"
  }, [_vm._v("Turning mere ideas into actual products is our passion. While we may not be landing launch rockets, yet, we love what we build. Whether it be web, mobile, or gaming, we dabble in what we find interesting and challenging, not taking on projects solely for their commercial value.")]), _vm._v(" "), _c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('li', {
      key: index,
      on: {
        "click": _vm.scrollTop
      }
    }, [_c('router-link', {
      attrs: {
        "to": 'projects',
        "exact": ""
      }
    }, [_c('span', {
      staticClass: "side-notes"
    }, _vm._l((project.types), function(type, typeIndex) {
      return _c('span', {
        key: typeIndex,
        staticClass: "side-note"
      }, [_vm._v(_vm._s(type.title))])
    }), 0), _vm._v("\n            " + _vm._s(project.title) + "\n          ")])], 1)
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "easy",
    attrs: {
      "href": "mailto:stuff@studio308.co",
      "id": "contact-link"
    }
  }, [_vm._v("say what")])])
}]}

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/contact",
      "title": "Contact"
    }
  })], 1)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body",
    attrs: {
      "id": "copy"
    }
  }, [_c('div', {
    staticClass: "block block-left"
  }, [_c('p', [_vm._v("For all general inquiries:")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "link-main",
    attrs: {
      "href": "mailto:stuff@studio308.co"
    }
  }, [_vm._v("stuff@studio308.co")])]), _vm._v(" "), _c('p', [_vm._v("To inquire about investing in one of our projects:")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "link-main",
    attrs: {
      "href": "mailto:finance@studio308.co"
    }
  }, [_vm._v("finance@studio308.co")])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-right"
  }, [_c('p', [_vm._v("We want you to reach out to us. We're lonely. Have a question about one of our projects? We guarantee it's not a dumb question because there's no such thing, so ask away. Need a few guns for hire for something you're working on? We do that. Need to send your product to urgent care to see a doctor? We're open twenty-four seven. Just want to pay someone to build and maintain your product? Yeah, we do that, too. Maybe you have a sick idea you want implemented but don't have the technical or financial resources to get it to see the light of day? If we agree with your subjective assessment of the idea's sickness, we'll see if we can't figure out a way for all of us to benefit from forcing it into the light together. Or maybe you just want to tell us a funny joke or interesting quote or see if we share the same favorite movie. We're interested. Hit us up. Send us an email at "), _c('a', {
    staticClass: "link-main",
    attrs: {
      "href": "mailto:stuff@studio308.co"
    }
  }, [_vm._v("stuff@studio308.co")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Now if you saw a project on our site that made you think \"oh, I gotta be a part of that, and look at all this money I don't know what to do with\", then yep, you guessed it, we want you to get in touch with us. We even splurged and created a specific email address just for those facing dilemmas exactly like the one you're facing right now. Send us an email at "), _c('a', {
    staticClass: "link-main",
    attrs: {
      "href": "mailto:finance@studio308.co"
    }
  }, [_vm._v("finance@studio308.co")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/services",
      "title": "Services"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.menuServices), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ({
          el: service.hash,
          offset: -100
        }),
        expression: "{el: service.hash, offset: -100}"
      }],
      staticClass: "nav-item",
      class: _vm.activeService == service ? 'active' : null,
      on: {
        "click": function($event) {
          return _vm.setActiveService(index)
        }
      }
    }, [_vm._v(_vm._s(service.title))])])
  }), 0)])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sub-sections"
    }
  }, [_c('div', {
    staticClass: "sub-section",
    attrs: {
      "id": "services"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.services), function(service, index) {
    return _c('service', {
      key: index,
      attrs: {
        "service": service,
        "active": _vm.activeService == service
      },
      on: {
        "activated": function($event) {
          return _vm.setActiveService(index)
        }
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    staticClass: "align-right",
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("We want to help you out, and we do a lot of things, so odds are that what you need done matches up with what we're able to do. Whether you need help fleshing out your idea and how to implement it, or you need help building out what you've already planned, or you just need some things fixed and maintained, we've got you covered.")])])
}]}

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon",
    attrs: {
      "id": "toggle-menu"
    },
    on: {
      "click": _vm.toggleMenuState
    }
  }, [_c('div', {
    class: _vm.navIconClasses,
    attrs: {
      "id": "nav-icon"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
},staticRenderFns: []}

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-right",
    attrs: {
      "id": "mainmenu"
    }
  }, [_c('div', {
    attrs: {
      "id": "menu-content"
    }
  }, [_c('ul', {
    staticClass: "unstyled"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      on: {
        "click": _vm.handleNavigation
      }
    }, [_c('router-link', {
      staticClass: "main-nav-item",
      class: _vm.linkClasses(link),
      attrs: {
        "to": {
          name: link.to
        },
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "title": "Page Not Found"
    }
  })], 1)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body",
    attrs: {
      "id": "copy"
    }
  }, [_c('h1', [_vm._v("Oops! We couldn't find the page you are looking for.")]), _vm._v(" "), _c('h2', [_vm._v("We're doing a remodel, so the page may be here the next time you visit.")])])
}]}

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "id": "page-title"
    }
  }, [(_vm.link) ? _c('router-link', {
    attrs: {
      "to": _vm.link,
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _c('span', [_vm._v(_vm._s(_vm.title))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project",
    attrs: {
      "id": _vm.project.alias
    }
  }, [_c('h2', {
    staticClass: "heading"
  }, [(_vm.project.links.website) ? _c('span', [_c('a', {
    attrs: {
      "href": _vm.project.links.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.project.title))])]) : _c('span', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('small', {
    staticClass: "side-note",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._l((_vm.project.types), function(type, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'project-type',
          params: {
            alias: type.alias
          }
        }
      }
    }, [_vm._v(_vm._s(type.title))])
  }), _vm._v(" \n    ")], 2)]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.project.description))]), _vm._v(" "), _c('p', {
    staticClass: "status",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('router-link', {
    staticClass: "hover-light",
    attrs: {
      "to": {
        name: 'project-status',
        params: {
          alias: _vm.project.status.alias
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.status.title))])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('span', {
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      },
      "id": "copyright-link"
    }
  }, [_c('icon', {
    attrs: {
      "name": "copyright",
      "scale": "1"
    }
  }), _vm._v(" 2017 " + _vm._s(_vm.studio308.name) + "\n    ")], 1), _vm._v(" -\n  ")], 1), _vm._v(" "), _c('a', {
    staticClass: "scroll-top pointer easy",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v("TOP "), _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("↑")])])])
},staticRenderFns: []}

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/team",
      "title": "Team"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sub-sections"
    }
  }, [_c('div', {
    staticClass: "sub-section",
    attrs: {
      "id": "team"
    }
  }, [(_vm.teammates.length) ? _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.teammates), function(teammate, index) {
    return _c('teammate', {
      key: index,
      attrs: {
        "teammate": teammate,
        "github-username": teammate.github_username
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('h1', {
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Our team is the all-star team of all-star teams. At least we think so. We value individuality in order to maximize different ways to approach a project. Our team brings a vast array of experience from various fields in order to create the best web, mobile, and game products we can.")])])
}]}

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "link": "/about",
      "title": "About"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "body",
    attrs: {
      "id": "copy"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.studio308.description))]), _vm._v(" "), _c('p', [_vm._v("We do a lot of things. Anything from fleshing out an idea and figuring out how to implement it, or building out what's already planned, or maybe just fixing and maintaining something that already exists. We do a lot of things. And we really enjoy doing it.")]), _vm._v(" "), _c('p', [_vm._v("What we love is to help great people and companies realize great products. Time is precious, and because of that we make sure that we believe in the people we work with. It could be that their product is going to do a lot of good, or that we share similar values with the people involved, but whatever the reason they came to work with us, our clients are all very special to us.")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", function() {
    return [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
      return _c('path', _vm._b({
        key: ("path-" + i)
      }, 'path', path, false))
    }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
      return _c('polygon', _vm._b({
        key: ("polygon-" + i)
      }, 'polygon', polygon, false))
    }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
      domProps: {
        "innerHTML": _vm._s(_vm.raw)
      }
    })] : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "footer-content align-center"
  }, [_c('p', [_vm._v("You gotta get in touch with us! Let's make some really great stuff.")]), _vm._v(" "), _c('contact-button')], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-footer"
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('social-icons', {
    attrs: {
      "scale": 1.5,
      "twitter": _vm.studio308.links.twitter,
      "github": _vm.studio308.links.github,
      "instagram": _vm.studio308.links.instagram,
      "linkedin": _vm.studio308.links.linkedin,
      "google-plus": _vm.studio308.links.google_plus,
      "facebook": _vm.studio308.links.facebook
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right-side"
  }, [_c('copyright')], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: _vm.active ? 'active' : null,
    attrs: {
      "id": _vm.service.title.toLowerCase()
    },
    on: {
      "click": _vm.makeActive
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.service.title))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.service.description))])])])
},staticRenderFns: []}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    class: _vm.appClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('navigation-icon', {
    attrs: {
      "nav-icon-classes": _vm.navIconClasses
    },
    on: {
      "toggle-menu-state": _vm.toggleMenuState
    }
  })], 1), _vm._v(" "), _c('navigation-menu', {
    on: {
      "navigating": _vm.closeMenu
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    },
    on: {
      "click": _vm.closeMenu
    }
  }, [_c('router-view', {
    attrs: {
      "scrollPosition": _vm.scrollPosition
    }
  }), _vm._v(" "), _c('page-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[47]);


// WEBPACK FOOTER //
// static/js/app.js?v=1.3.8